<div
  id="gcc-slider-superior"
  *ngIf="ativo"
  [style.backgroundColor]="backgroundColor"
  [style.color]="fontColor"
>
  <div
    *ngFor="let text of values"
    class="text-center"
    [style.fontSize.px]="fontSize"
  >
    {{ text }}
  </div>
</div>
